import { RemixBrowser } from "@remix-run/react";
import { init } from "@sentry/remix";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

init({
    dsn: "https://8f5c487ccf34da31b7e0951d8eb9ff80@o4510791340195840.ingest.us.sentry.io/4510791633272832",
    enableLogs: true
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});